/*----- AUTH users -------------------------------------------------------------------*/
export default {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    current_user: state => state.current_user,
    branch: state => state.current_user.branch || {},
    permissions: state => state.current_user.permissions
};
